<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title' v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  name:'app',
  provide(){
    return {
      reloadLoad:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },
  methods:{
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
/* 开始  美化滚动条 目前只美化谷歌浏览器 */
/* 谷歌浏览器滚动条样式 */
::-webkit-input-placeholder {
  text-overflow: ellipsis;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  overflow: auto;
}

::-webkit-scrollbar-thumb {
  background-color: #dddee0;
  min-height: 25px;
  min-width: 25px;
  border: 1px solid #dddee0;
}

::-webkit-scrollbar-track {
  background-color: #fff;
  border: 1px solid #fff;
}

/* 火狐浏览器滚动条样式 */
* {
  scrollbar-color: #dddee0 #fff; /* 滑块颜色  滚动条背景颜色 */
  scrollbar-width: thin; /* 滚动条宽度有三种：thin、auto、none */
}
/* 结束  美化滚动条 目前只美化谷歌浏览器 */
/* 开始  处理el-table  表头对不齐 */
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
/* 结束  处理el-table  表头对不齐 */
</style>


// WEBPACK FOOTER //
// src/App.vue